<template>
  <div class="swiper-box">
    <div class="swiper">
      <div class="swiper-wrapper">
        <div
          v-for="(car) in allLists"
          :key="car.id"
          class="swiper-slide"
        >
          <div
            v-if="car.type === '急救车'"
            class="current-mission car"
            :class="{isWait: car.statu!== '发车中'}"
            @click="checkMission(car)"
          >
            <div class="car-name">{{ car.name }}</div>
          </div>
          <div
            v-else-if="car.type === '无人车'"
            class="current-mission smart-car"
            :class="{isWait: car.statu!== '发车中'}"
            @click="checkMission(car)"
          >
            <div class="car-name">{{ car.name }}</div>
          </div>
          <div
            v-else
            class="current-mission fly"
            :class="{isWait: car.statu!== '发车中'}"
            @click="checkMission(car)"
          >
            <div class="car-name">{{ car.name }}</div>
          </div>
        </div>
      </div>

    </div>
    <div class="nav-button">
      <div>
        <div class="swiper-button-prev"/>
      </div>
      <div>
        <div class="swiper-button-next"/>
      </div>
    </div>
    <small-dialog :dialog-show="dialogWarning" @closeDialog="dialogWarning=false">
      <div>本车（{{ idName }}）暂无急救任务</div>
    </small-dialog>
  </div>
</template>

<script>
import Swiper from "swiper";
import SmallDialog from "@/components/customDialog/SmallDialog";
import "swiper/swiper-bundle.css"; // css 模块

export default {
  name: "IndexSwiper",

  components: { SmallDialog },

  props: {
    allLists: {
      type: Array,
      default() {
        return [];
      },
    },
    smartCarLists: {
      type: Array,
      default() {
        return [];
      },
    },
    flyLists: {
      type: Array,
      default() {
        return [];
      },
    }
  },
  data() {
    return {
      dialogWarning: false,
      idName: ""
    };
  },
  mounted() {
    setTimeout(() => {
      new Swiper(".swiper", {
        loop: true, // 循环模式选项
        // width: 400,
        // autoplay: true, // 等同于以下设置
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        slidesPerView: 5,
        autoWidth: true,
        // slidesPerGroup: 3,
        freeModeSticky: true,
        grabCursor: "true",
        observer: "true",
        observeParents: "true",
      });
    }, 300);
  },
  methods: {
    checkMission(item) {
      const { statu, id, idName, type } = item;
      if (statu === "发车中") {
        const map = {
          "无人车": { router: "/autoMobileLive/", category: "autoMobile", selected: "isShowAutoMobileLive" },
          "无人机": { router: "/planeLive/", category: "helicopter", selected: "isShowPlaneLive" },
          "急救车": { router: "/showAmbulance/", category: "car", selected: "liveCarCondition" }
        };
        const { category, selected, router } = map[type];
        const query = { category, id, selected };
        this.$router.push({
          path: router + id,
          query
        }).catch(e => {
          console.error(e);
        });
      } else {
        this.dialogWarning = true;
        this.idName = idName;
      }
    }
  }
};
</script>

<style scoped lang="scss">

.swiper ::v-deep {
  width: 100%;
  margin-top: 25px;
  position: relative;
  overflow: hidden;
}

.current-mission.car {
  background: url(../../assets/photos/working.png) no-repeat center center;
}

.current-mission.isWait.car {
  background: url(../../assets/photos/waiting.png) no-repeat center center;
}

.current-mission.smart-car {
  background: url(../../assets/photos2/smartCar-working.png) no-repeat center center;
}

.current-mission.isWait.smart-car {
  background: url(../../assets/photos2/smartCar-working.png) no-repeat center center;
}

.current-mission.fly {
  background: url(../../assets/photos2/fly-working.png) no-repeat center center;
}

.current-mission.isWait.fly {
  background: url(../../assets/photos2/fly-working.png) no-repeat center center;
}

.current-mission {
  text-align: center;
  width: 256px;
  background: #FBFBFB;
  box-shadow: 0 0 6px 0 rgba(127, 147, 166, 0.5);
  border-radius: 10px;
  margin: 2px auto;
  height: 202px;
  position: relative;

  .car-name {
    font-size: 16px;
    color: #666666;
    height: 52px;
    line-height: 52px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -10px;
  }
}

.nav-button {
  position: absolute;
  top: 24px;
  right: 35px;
  display: flex;

  > div {
    width: 32px;
    height: 32px;
    background: #FBFBFB;
    box-shadow: 0 0 4px 0 rgba(139, 139, 139, 0.4);
    border-radius: 10px;
  }

  > div:first-child {
    margin-right: 24px;
  }

  .swiper-button-next,
  .swiper-button-prev {
    position: unset;
    top: 0;
    height: 100%;
    margin: 0;
    width: 100%;
  }

  .swiper-button-next::after,
  .swiper-button-prev::after {
    width: 100%;
    text-align: center;
    z-index: 2 !important;
    position: relative;
  }
}

.swiper-box {
  min-width: 1500px;
  //--swiper-theme-color: #ff6600; /* 设置Swiper风格 */
  font-weight: 700;
  --swiper-navigation-color: black; /* 单独设置按钮颜色 */
  --swiper-navigation-size: 16px; /* 设置按钮大小 */
}

.swiper-button-next:after,
.swiper-button-prev:after {
  font-family: swiper-icons;
  font-size: var(--swiper-navigation-size);
  text-transform: none !important;
  letter-spacing: 0;
  text-transform: none;
  font-variant: initial;
  line-height: 1;
}

.swiper-button-next:after {
  content: "next";
}

.swiper-button-prev:after {
  content: "prev";
}
</style>
